// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"452":"a0e53bee","548":"8de4b722","613":"3a335131","750":"2f5ce074","822":"cf03e014","826":"ed92731e"}[chunkId] + ".1793793499150.chunk.js";
};